<template>
  <div class="molded-seat-step-five">
    <v-switch
      v-model="form.socle_module.idc_socle"
      hide-details
      label="Socle :"
      class="title"
      @change="clearSocleFields"
    />
    <v-layout
      wrap
      justify-space-between
      mt-6
      mb-6
    >
      <v-flex sm3>
        <v-text-field
          v-model="form.socle_module.width"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Socle) Largeur') }"
          data-vv-name="(Socle) Largeur"
          class="mb-3"
          label="Largeur (mm)"
          type="number"
          hide-details
          outlined
          :disabled="!form.socle_module.idc_socle"
        />
      </v-flex>
      <v-flex sm3>
        <v-text-field
          v-model="form.socle_module.depth"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Socle) Profondeur') }"
          data-vv-name="(Socle) Profondeur"
          class="mb-3"
          label="Profondeur (mm)"
          type="number"
          hide-details
          outlined
          :disabled="!form.socle_module.idc_socle"
        />
      </v-flex>
      <v-flex sm3>
        <v-text-field
          v-model="form.socle_module.thickness"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Socle) Epaisseur') }"
          data-vv-name="(Socle) Epaisseur"
          class="mb-3"
          label="Epaisseur (mm)"
          type="number"
          hide-details
          outlined
          :disabled="!form.socle_module.idc_socle"
        />
      </v-flex>
      <v-flex sm3>
        <v-text-field
          v-model="form.socle_module.tilt"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('(Socle) Inclinaison') }"
          data-vv-name="(Socle) Inclinaison"
          class="mb-3"
          label="Inclinaison (mm)"
          type="number"
          hide-details
          outlined
          :disabled="!form.socle_module.idc_socle"
        />
      </v-flex>
      <v-flex sm4>
        <v-select
          v-model="form.socle_module.matter"
          :items="socleModule.matter"
          item-text="label"
          item-value="value"
          label="Matériau"
          class="mb-3"
          hide-details
          filled
          clearable
          :disabled="!form.socle_module.idc_socle"
          @click:clear="$nextTick(() => (form.socle_module.matter = null))"
        />
      </v-flex>
      <v-flex sm5>
        <v-layout class="color-select">
          <v-select
            v-model="form.socle_module.socle_color_id"
            :items="basesColors"
            item-text="label"
            item-value="id"
            hide-details
            label="Couleur"
            filled
            clearable
            :disabled="!form.socle_module.idc_socle"
          />
          <template v-if="previewBasesColor">
            <v-flex
              v-if="previewBasesColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewBasesColor.image"
                style="width: 100%; height: 100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewBasesColor.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': '#' + previewBasesColor.rgb_code }"
            />
          </template>
        </v-layout>
      </v-flex>
      <v-btn
        color="#880e4f"
        dark
        :disabled="!form.socle_module.idc_socle"
        @click="$emit('sketch-click')"
      >
        Schéma
      </v-btn>
    </v-layout>

    <v-switch
      v-model="form.headrest_module.idc_headrest"
      hide-details
      label="Têtière :"
      class="title"
      @change="clearHeadrestFields"
    />
    <v-layout
      wrap
      mt-6
    >
      <v-flex sm6>
        <v-layout
          column
          justify-space-between
          fill-height
        >
          <div class="radios-container">
            <v-radio-group
              v-model="form.headrest_module.renew"
              hide-details
              row
              class="mb-4"
              :disabled="!form.headrest_module.idc_headrest"
            >
              <v-radio
                label="Existant"
                value="EXISTING"
              />
              <v-radio
                label="Nouveau"
                value="NEW"
              />
            </v-radio-group>

            <v-radio-group
              v-model="form.headrest_module.type"
              hide-details
              row
              :disabled="!form.headrest_module.idc_headrest"
            >
              <v-radio
                label="Amovible"
                value="REMOVABLE"
              />
              <v-radio
                label="Réglable"
                value="ADJUSTABLE"
              />
              <v-radio
                label="Intégré"
                value="EMBEDDED"
              />
            </v-radio-group>
          </div>
          <div class="content img1">
            <div class="img-container">
              <img src="@/assets/img/schema_verticalisateur_3a.svg">
              <v-text-field
                v-model="form.headrest_module.a"
                v-validate="'numeric|max:4'"
                :class="{ error: errors.has('(Têtière) A') }"
                data-vv-name="(Têtière) A"
                outlined
                type="number"
                style="top: 23.1%; left: 42.2%"
                s
                height="100%"
                :disabled="!form.headrest_module.idc_headrest"
              />
              <v-text-field
                v-model="form.headrest_module.b"
                v-validate="'numeric|max:4'"
                :class="{ error: errors.has('(Têtière) B') }"
                data-vv-name="(Têtière) B"
                outlined
                type="number"
                style="top: 79%; left: 42.2%"
                height="100%"
                :disabled="!form.headrest_module.idc_headrest"
              />
            </div>
          </div>
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <v-radio-group
          v-model="form.headrest_module.headrest_type"
          v-validate
          hide-details
          class="mb-4"
          :disabled="!form.headrest_module.idc_headrest"
        >
          <v-layout
            class="checkbox-input-container mb-3"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Albatros"
                value="ALBATROS"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.headrest_module.albatros_size"
                v-validate="{
                  required: form.headrest_module.headrest_type == 'ALBATROS',
                }"
                name="Taille Albatros"
                :items="headrestModule.albatros"
                item-text="label"
                item-value="value"
                label="Taille Albatros"
                hide-details
                filled
                clearable
                :disabled="
                  !form.headrest_module.idc_headrest ||
                    form.headrest_module.headrest_type !== 'ALBATROS'
                "
                @click:clear="
                  $nextTick(() => (form.headrest_module.albatros_size = null))
                "
              />
            </v-flex>
          </v-layout>
          <v-radio
            label="Moulé"
            value="MOULDED"
            class="mb-4"
          />
          <v-radio
            label="Sur mesure"
            value="CUSTOM_MADE"
          />
        </v-radio-group>
        <v-switch
          v-model="form.headrest_module.idc_thierry"
          hide-details
          label="Thierry"
          class="mb-4"
          :disabled="!form.headrest_module.idc_headrest"
        />

        <v-layout mb-3>
          <v-text-field
            v-model="form.headrest_module.finishing"
            label="Finition"
            hide-details
            outlined
            maxlength="15"
            :disabled="!form.headrest_module.idc_headrest"
          />
        </v-layout>

        <v-select
          v-model="form.headrest_module.mounting"
          :items="headrestModule.mounting"
          item-text="label"
          item-value="value"
          label="Fixation :"
          class="mb-3"
          hide-details
          filled
          clearable
          :disabled="!form.headrest_module.idc_headrest"
          @click:clear="
            $nextTick(() => (form.headrest_module.mounting = null))
          "
        />

        <v-layout justify-space-between>
          <v-radio-group
            v-model="form.headrest_module.mounting_type"
            hide-details
            row
            class="mb-4"
            :disabled="!form.headrest_module.idc_headrest"
          >
            <v-radio
              label="Tube carré"
              value="SQUARE_TUBE"
            />
            <v-radio
              label="En fer Plat"
              value="FLAT_IRON"
            />
          </v-radio-group>
        </v-layout>

        <v-select
          v-model="form.headrest_module.vital_scrolling"
          :items="headrestModule.vital_scrolling"
          item-text="label"
          item-value="value"
          hide-details
          filled
          clearable
          :disabled="!form.headrest_module.idc_headrest"
          @click:clear="
            $nextTick(() => (form.headrest_module.vital_scrolling = null))
          "
        />
      </v-flex>
    </v-layout>
    <v-layout
      justify-center
      align-center
      class="mt-12"
    >
      <div class="content img2">
        <div class="img-container">
          <img
            class="mb-5"
            src="@/assets/img/schema_siegemoule_6b.svg"
          >
          <v-text-field
            v-model="form.headrest_module.c"
            v-validate="'numeric|max:4'"
            :class="{ error: errors.has('(Têtière) C') }"
            data-vv-name="(Têtière) C"
            outlined
            type="number"
            style="top: 22.6%; left: 88.1%"
            s
            height="100%"
            :disabled="!form.headrest_module.idc_headrest"
          />
        </div>
      </div>
    </v-layout>

    <v-textarea
      v-model="form.headrest_comment"
      filled
      name="Ajouter un commentaire :"
      label="Ajouter un commentaire :"
      :disabled="!form.headrest_module.idc_headrest"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepFive",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      basesColors: "colors/getBASESType",

      socleModule: "dropdowns/getSocleOptions",
      headrestModule: "dropdowns/getHeadRestOptions",
    }),

    previewBasesColor() {
      return this.basesColors.find(
        (color) => color.id == this.form.socle_module.socle_color_id
      );
    },
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear headrest fields
    clearHeadrestFields() {
      this.form.headrest_module.renew = null;
      this.form.headrest_module.type = null;
      this.form.headrest_module.headrest_type = null;
      this.form.headrest_module.albatros_size = null;
      this.form.headrest_module.mounting_type = null;
      this.form.headrest_module.idc_thierry = false;
      this.form.headrest_module.vital_scrolling = null;
      this.form.headrest_module.finishing = null;
      this.form.headrest_module.mounting = null;
      this.form.headrest_module.a = null;
      this.form.headrest_module.b = null;
      this.form.headrest_module.c = null;
    },

    // Clear headrest fields
    clearSocleFields() {
      this.form.socle_module.depth = null;
      this.form.socle_module.idc_schematic = false;
      this.form.socle_module.matter = null;
      this.form.socle_module.socle_color_id = null;
      this.form.socle_module.thickness = null;
      this.form.socle_module.tilt = null;
      this.form.socle_module.width = null;
    },
  },
};
</script>

<style lang="scss">
.molded-seat-step-five {
  .content {
    display: flex;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 15.8%;
          height: 17.8%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 11.8%;
          height: 27.8%;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .sm6 {
    flex-basis: calc(100% / 2 - 7px);
  }
}
</style>
